/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionCustomerGranteesMutation($input: SaveSouscriptionCustomerGrantees_M_souscription_customer_granteesInput!) {
    saveSouscriptionCustomerGrantees_M_souscription_customer_grantees(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
